import { render } from "./MyProjectsPage.vue?vue&type=template&id=2fae05a0"
import script from "./MyProjectsPage.vue?vue&type=script&lang=js"
export * from "./MyProjectsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__